import { createListQuery, toUpperCase } from '../utils'
import { createSharedComposable } from '@vueuse/core'

export const useMode = createSharedComposable(() => {
    return createListQuery(
        'mode',
        [{ label: 'Data', value: 'DATA' as const }],
        {
            normalize: toUpperCase,
            defaultValue: undefined
        }
    )
})
